export enum BillPaymentStatus {
    Paid = 1,
    PartialPaid = 2,
    UnPaid = 3
}
export const BillPaymentStatusLabels: Record<BillPaymentStatus, string> = {
    [BillPaymentStatus.Paid]: "Paid",
    [BillPaymentStatus.PartialPaid]: "PartialPaid",
    [BillPaymentStatus.UnPaid]: "UnPaid",
};
